
<template >
  <!-- <div class="container">     -->
  <card-seplag>
    <div class="p-col-12 div-flex-inicio">
      <label style="font-size: 2rem; color: #607d8b">{{
        `DBV - Declaração de Bens e Valores
                            ${
                              exercicioVigente
                                ? exercicioVigente.anoExercicio
                                : ""
                            }`
      }}</label>

      <h2 class="texto-recadastramento" v-if="exercicioVigente">
        <strong>
          Período de envio da declaração de bens anual: Data encerramento:
          {{ exercicioVigente.dataFimEnvio }}
        </strong>
      </h2>

      <div
        class="p-grid"
        v-if="
          exercicioVigente &&
          declaracaoAtual &&
          declaracaoAtual.statDeclaracao == 'NAO_INICIADA' &&
          exercicioVigente.statParExercicio == 'ATIVO' &&
          isPodeDeclarar
        "
      >
        <div class="p-col-12 p-md-12">
          <Button
            icon="pi pi-list"
            label="Iniciar Declaração"
            class="p-button-raised p-button-rounded"
            @click="getDadosPessoa()"
          />
        </div>
      </div>

      <div v-if="listaDeclaracao.length > 0">
        <DataTable
          :value="listaDeclaracao"
          class="p-datatable-responsive-demo p-datatable-gridlines"
        >
          <Column
            field="anoExercicio"
            header="Exercício"
            headerStyle="width: 8rem"
            bodyClass="columnAlign"
          >
            <template #body="slotProps">
              <span class="p-column-title">Exercício:</span>
              {{ slotProps.data.anoExercicio }}
            </template>
          </Column>

          <Column
            field="cpfFormatado"
            header="CPF"
            headerStyle="width: 9rem"
            bodyClass="columnAlign"
          >
            <template #body="slotProps">
              <span class="p-column-title">CPF:</span>
              {{ slotProps.data.cpfFormatado }}
            </template>
          </Column>

          <Column field="nomePessoa" header="Nome">
            <template #body="slotProps">
              <span class="p-column-title">Nome:</span>
              {{ slotProps.data.nomePessoa }}
            </template>
          </Column>

          <Column
            field="dataEnvio"
            header="Data Inclusão da Declaração"
            headerStyle="width: 9rem"
            bodyClass="columnAlign"
          >
            <template #body="slotProps">
              <span class="p-column-title">Data Inclusão da Declaração:</span>
              <!--moment(slotProps.data.dataEnvio).format("currency-pt-br")-->
              <label>{{ slotProps.data.dataEnvio }}</label>
            </template>
          </Column>

          <Column
            field="dataProtocolo"
            header="Data Comprovante"
            headerStyle="width: 9rem"
            bodyClass="columnAlign"
          >
            <template #body="slotProps">
              <span class="p-column-title">Data Comprovante:</span>
              {{ slotProps.data.dataProtocolo }}
            </template>
          </Column>

          <Column
            field="statDeclaracaoDescricao"
            header="Situação"
            headerStyle="width: 9rem"
            bodyClass="columnAlign"
          >
            <template #body="slotProps">
              <span class="p-column-title">Situação:</span>
              {{ slotProps.data.statDeclaracaoDescricao }}
            </template>
          </Column>

          <!-- <Column field="flagMotivoRecusa" header="Motivo da Recusa" headerStyle="width: 9rem" bodyClass="columnAlign" > 
                                <template #body="slotProps">
                                    <span class="p-column-title">Motivo da Recusa:</span>
                                    {{slotProps.data.flagMotivoRecusa}}
                                </template>
                                                                                                                    </Column> -->

          <Column
            headerStyle="width: 15em"
            bodyClass="columnAlign"
            header="Ação"
          >
            <template #body="slotProps">
              <Button
                type="button"
                icon="pi pi-eye"
                class="p-button-raised"
                style="margin-right: 0.3rem"
                @click="visualizarExercicio(slotProps.data)"
                v-tooltip.top="'Visualizar'"
              ></Button>
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-warning btn-editar-branco"
                style="margin-right: 0.3rem"
                v-if="isPermitiEditar(slotProps.data)"
                @click="editarExercicio(slotProps.data)"
                v-tooltip.top="
                  slotProps.data.statDeclaracao == 'TERMO_ACEITO'
                    ? 'Preencher'
                    : 'Editar'
                "
              ></Button>

              <Button
                @click="OpenDialog(slotProps.data)"
                icon="pi pi-times"
                class="p-button-danger"
                v-if="
                  isPermitiExcluir(slotProps.data) && slotProps.data.dataEnvio
                "
                style="margin-right: 0.3rem"
                v-tooltip.top="'Excluir'"
              ></Button>

              <Button
                type="button"
                icon="pi pi-print"
                @click="impressao(slotProps.data)"
                class="p-button-raised"
                v-if="slotProps.data.numrProtocolo"
                v-tooltip.top="'Imprimir'"
              ></Button>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <Dialog
      header="TERMO DE ACEITE"
      :visible.sync="dialogNaoConcordo"
      :contentStyle="{ width: 'auto' }"
      :modal="true"
      :closable="false"
    >
      <div class="div-container-termo" v-if="exercicioVigente.termo">
        <p v-if="exercicioVigente.termo.descTermo" class="titulo">
          {{ exercicioVigente.termo.descTermo }}
        </p>
        <div
          v-if="exercicioVigente.termo.infoTermo"
          v-html="exercicioVigente.termo.infoTermo"
        ></div>
      </div>
      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="fecharDialogo"
          class="button-fechar-termo"
        />
        <Button
          label="Aceitar"
          icon="pi pi-check"
          @click="aceitoTermo()"
          autofocus
        />
      </template>
    </Dialog>

    <ExibirPDF
      v-if="pdfBase64"
      v-model="exibirPDFDocumento"
      :tamanhoTela="'70,vw'"
      :alturaTela="'30,vw'"
      :tituloTela="nomeModalPDF"
      :pdfElement="pdfBase64"
    />

    <Dialog
      :visible.sync="deleteDeclaracaoDialog"
      :style="{ width: '450px' }"
      header="Confirmação de Exclusão"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="selectedDeclaracao">
          Você tem certeza que deseja EXCLUIR essa declaração?
          <br /><br />
          Obs: O Protocolo atual será excluído, você terá que realizar uma nova
          declaração para gerar um novo Protocolo.
        </span>
      </div>
      <template #footer>
        <Button
          label="Não"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteDeclaracaoDialog = false"
        />
        <Button
          label="Sim"
          icon="pi pi-check"
          class="p-button-text"
          @click="excluir"
        />
      </template>
    </Dialog>

    <Dialog
      header="Confirmação de Edição"
      :visible.sync="showConfirmEdicao"
      :modal="true"
      :style="{ maxWidth: '29rem' }"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span :style="{ fontWeight: 400 }">
          Você tem certeza que deseja EDITAR essa declaração?
          <br /><br />
          Obs: O protocolo atual será excluído, você terá que finalizar a edição
          para gerar um novo Protocolo.
        </span>
      </div>

      <template #footer>
        <Button
          label="Não"
          icon="pi pi-times"
          @click="showConfirmEdicao = false"
          class="p-button-text"
        />
        <Button
          label="Sim"
          icon="pi pi-check"
          @click="confirmarEdicao"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </card-seplag>

  <!-- </div> -->
</template>
<script>
// import Rotulo from '@/template/RotuloSeplag.vue'
import CardSeplag from "@/template/CardSeplag.vue";
import ExibirPDF from "@/template/CardExibirPDF.vue";
import { baseApiUrl, printToast } from "@/config/global";
import moment from "moment";

const schemaExercicioVigente = () => {
  return {
    anoExercicio: 0,
    dataFimEnvio: "",
    dataFimValidacao: "",
    dataInicioEnvio: "",
    dataInicioValidacao: "",
    idenParExercicio: 0,
    numrAnoCalendario: 0,
    statParExercicio: "",
    termo: null,
  };
};

export default {
  name: "dashBoard",
  components: { CardSeplag, ExibirPDF },
  data: function () {
    return {
      exercicioVigente: schemaExercicioVigente(),
      ciclopessoa: this.$store.getters.getCicloPessoa,
      home: { label: "Dados Pessoais", to: "/" },
      dialogNaoConcordo: false,
      visaoEmpressao: false,
      dataImpressao: moment().locale("pt-br").format("LLL"),
      dataInicioClico: null,
      dataFimClico: "30/05/2021",
      exibirPDFDocumento: true,
      pdfBase64: "",
      nomeModalPDF: "MODAL PDF",
      exibirComprovante: true,
      isFaseEditar: true,
      listaDeclaracao: [],
      AnoVigente: "",
      declaracaoAtual: null,
      deleteDeclaracaoDialog: false,
      selectedDeclaracao: null,
      idenContaAcesso: 0,
      showConfirmEdicao: false,
      dadosSelecionado: null,
      isPodeDeclarar: true,
    };
  },
  methods: {
    carregarDados() {
      let perfisUser = this.$store.getters.getUser.contaAcesso.perfis;
      if (perfisUser.length > 0) {
        perfisUser.forEach((p) => {
          if (p.perfilAcesso.nomePerfilAcesso == "FISCALIZADOR - DECLARACAO") {
            // buscar VInculo a partir do idenPerfilVinculo
            this.$http
              .get(
                `${baseApiUrl}/seguranca/perfilacessos/vinculo/perfil/${p.idenPerfilVinculo}`
              )
              .then((res) => {
                let perfilVinculo = res.data;
                if (perfilVinculo.vinculo.tipoVinculo.nomeRole == "EXTERNO") {
                  this.isPodeDeclarar = false;
                }
              });
          }
        });
      }
      let now = new Date();
      this.AnoVigente = now.getFullYear();
      let idenPessoa =
        this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa;
      this.idenContaAcesso = this.$store.getters.getUser.contaAcesso.id;

      this.$http
        .get(`${baseApiUrl}/parametroexercicios/vigente`)
        .then((res) => {
          this.exercicioVigente = res.data;
          if (!res.data.termo.infoTermo.startsWith(`<div class="ql-editor">`)) {
            this.exercicioVigente.termo.infoTermo =
              `<div class="ql-editor">` + res.data.termo.infoTermo + "</div>";
          }
          
          if(this.isPodeDeclarar){
            let regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/;
            let match = regex.exec(res.data.dataFimEnvio);
            if(match){
              let [, day, month, year, hours, minutes, seconds] = match;
              let dateFimEnvio = new Date(year, month - 1, day, hours, minutes, seconds);
              if(dateFimEnvio <= now){
                this.isPodeDeclarar = false;
              }
            }
          }
        });

      this.$http
        .get(`${baseApiUrl}/pessoaexercicios/pessoa/${idenPessoa}`)
        .then((res) => {
          this.listaDeclaracao = res.data.content;
          this.declaracaoAtual = this.listaDeclaracao.find(
            (element) => element.anoExercicio == this.AnoVigente
          );
          if (
            this.declaracaoAtual &&
            this.declaracaoAtual.statDeclaracao == "NAO_INICIADA"
          ) {
            this.listaDeclaracao = this.listaDeclaracao.filter(
              (element) =>
                element.anoExercicio != this.declaracaoAtual.anoExercicio
            );
          }
        });
    },
    impressao(data) {
      this.$http
        .get(
          `${baseApiUrl}/relatorios/comprovantedeclaracao/${data.idenPessoaExercicio}`
        )
        .then((res) => {
          this.pdfBase64 =
            "data:application/pdf;base64," + res.data.dadosRelatorioBase64;
          this.nomeModalPDF = res.data.nomeArquivo;
          this.exibirPDFDocumento = true;
        });
    },
    getDadosPessoa() {
      if (this.declaracaoAtual.flagAceiteTermo == "N") {
        this.dialogNaoConcordo = true;
      } else {
        this.$router.push({
          name: "formDeclaracaoBensEdit",
          params: { id: this.declaracaoAtual.idenPessoaExercicio },
        });
      }
    },
    aceitoTermo() {
      this.$http
        .put(
          `${baseApiUrl}/pessoaexercicios/termoaceite/${this.declaracaoAtual.idenPessoaExercicio}/${this.idenContaAcesso}`
        )
        .then(() => {
          this.dialogNaoConcordo = false;
          this.$router.push({
            name: "formDeclaracaoBensEdit",
            params: { id: this.declaracaoAtual.idenPessoaExercicio },
          });
        });
    },
    fecharDialogo() {
      printToast({
        severity: "error",
        summary: "Declaração não iniciada",
        detail:
          "Para Iniciar a Declaração de Bens você precisa “ACEITAR O TERMO”;",
      });
      this.dialogNaoConcordo = false;
    },
    onEditarBem(data) {
      this.$router.push({
        name: "formDeclaracaoBensEdit",
        params: { id: data.idenPessoaExercicio },
      });
    },
    isPermitiEditar(data) {
      if (this.exercicioVigente) {
        let today = new Date();    
        let dataFimEnvioDate = new Date();
        let regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/;
        let match = regex.exec(this.exercicioVigente.dataFimEnvio);
        if(match){
          let [, day, month, year, hours, minutes, seconds] = match;
          dataFimEnvioDate = new Date(year, month - 1, day, hours, minutes, seconds);
        }
        let validacaoDataFimEnvio = today <= dataFimEnvioDate;
        let validacaoAnoExercicio =
          this.exercicioVigente.anoExercicio == data.anoExercicio;
        // let validacaoSituacao = data.statDeclaracao == "FINALIZADA"

        return validacaoDataFimEnvio && validacaoAnoExercicio; //&& !validacaoSituacao
      } else {
        return false;
      }
    },
    isPermitiExcluir(data) {
      if (this.exercicioVigente) {
        let today = new Date();
        let dataFimEnvioDate = new Date();
        let regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/;
        let match = regex.exec(this.exercicioVigente.dataFimEnvio);
        if(match){
          let [, day, month, year, hours, minutes, seconds] = match;
          dataFimEnvioDate = new Date(year, month - 1, day, hours, minutes, seconds);
        }
        let validacaoDataFimEnvio = today <= dataFimEnvioDate;
        let validacaoAnoExercicio =
          this.exercicioVigente.anoExercicio == data.anoExercicio;
        // let validacaoSituacao = data.statDeclaracao == "FINALIZADA"

        return validacaoDataFimEnvio && validacaoAnoExercicio; //&& !validacaoSituacao
      } else {
        return false;
      }
    },
    OpenDialog(data) {
      this.selectedDeclaracao = { ...data };
      this.deleteDeclaracaoDialog = true;
    },
    excluir() {
      this.$http
        .put(
          `${baseApiUrl}/pessoaexercicios/desativar/${this.selectedDeclaracao.idenPessoaExercicio}/${this.idenContaAcesso}`
        )
        .then((res) => {
          printToast({
            severity: "success",
            summary: "Declaração Excluída",
            detail: res.data,
          });
          this.deleteDeclaracaoDialog = false;
          this.carregarDados();
        });
    },

    visualizarExercicio(data) {
      this.$router.push({
        name: "formDeclaracaoBensVisualizar",
        params: { id: data.idenPessoaExercicio },
      });
    },
    editarExercicio(data) {
      this.showConfirmEdicao = true;
      this.dadosSelecionado = { ...data };
    },
    confirmarEdicao() {
      this.showConfirmEdicao = false;

      this.$http
        .put(
          `${baseApiUrl}/pessoaexercicios/preparaedicao/${this.dadosSelecionado.idenPessoaExercicio}`
        )
        .then(() => {
          this.$router.push({
            name: "formDeclaracaoBensEdit",
            params: { id: this.dadosSelecionado.idenPessoaExercicio },
          });
        });
    },
  },
  mounted() {
    this.carregarDados();
  },
  watch: {
    exibirPDFDocumento: function (val) {
      if (!val) {
        this.pdfBase64 = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: auto auto;
}

.p-button-warning {
  font-weight: bold;
}

/deep/ .btn-editar-branco .pi,
/deep/ .btn-editar-branco .p-button-icon {
  color: #fff !important;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 60em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-row {
        display: flex;
        flex-direction: column;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: center !important;
          display: flex !important;

          & button {
            width: 100%;
          }
        }
      }
    }
  }
}

.modal-monitora {
  width: 70rem;
  left: 28rem;
}

.dadosComprovante {
  border: 1px solid black;
  border-radius: 5px;
  max-width: 73.1em;
  text-align: center;
}

.dadosComprovante tr,
td {
  text-align: center;
  margin-right: 50px;
}

.hr-modal {
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.texto-recadastramento {
  font-family: Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif;
  color: rgb(96, 125, 139);
  margin: 2rem auto;
}

.texto-centro {
  text-align: center;
}

.img-logo-estado {
  width: 30%;
}

.titulo-card-protocolo {
  margin-bottom: 1vw;
}

.hr-visivel-sm {
  display: none;
}

.protocolo {
  font-size: 20px;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.product-badge.status-validado {
  background: #c8e6c9;
  color: #256029;
}

.product-badge.status-aguardando {
  background: #feedaf;
  color: #8a5340;
}

.product-badge.status-PENDENTE {
  background: #ffcdd2;
  color: #c63737;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}

.display-flex-buttons {
  display: flex;
  flex: 1;
  margin: 1rem;
  justify-content: flex-end;
  align-items: stretch;
}

.display-flex-buttons > div:first-child {
  margin-right: 1rem;
}

.display-flex-buttons button {
  font-size: 1.1rem;
}

.display-flex-buttons > div button {
  height: 100%;
}

.div-flex-inicio {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-around;
  align-items: center;
}

.div-container-termo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.div-container-termo .titulo {
  margin-bottom: 1rem;
  font-weight: bold;
  font-size: 1.214rem;
}

.div-container-termo .subtitulo {
  margin: 1rem auto;
  font-size: 1.071rem;
}

.div-container-termo p {
  line-height: 1.5;
  font-size: 0.928rem;
  font-family: Arial, verdana, sans-serif;
  margin: 0.5rem auto;
}

@media screen and (max-width: 40em) {
  .p-dialog-content {
    width: 100% !important;
  }
}

.button-fechar-termo {
  background-color: transparent;
  color: #2196f3;
  border-color: transparent;
}

.button-fechar-termo:enabled:hover {
  background: rgba(33, 150, 243, 0.04);
  color: #2196f3;
  border-color: transparent;
}

.columnAlign {
  text-align: center;
}
</style>